import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-268c9a0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "svg-container" }
const _hoisted_2 = { class: "loading_text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "path",
  id: "svg2",
  viewBox: "0 0 500 670",
  width: "200px",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:bx": "https://boxy-svg.com"
}, [
  /*#__PURE__*/_createElementVNode("desc", null, "Source: openclipart.org/detail/209545"),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("linearGradient", {
      id: "color-0",
      gradientUnits: "userSpaceOnUse",
      "bx:pinned": "true"
    }, [
      /*#__PURE__*/_createElementVNode("stop", { style: {"stop-color":"rgb(0, 0, 0)"} })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "88.394",
    y: "42.275",
    width: "303.614",
    height: "581.606",
    style: {"fill":"none","fill-rule":"nonzero","stroke":"url(\"#color-0\")"}
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "131.95",
    y: "81.989",
    width: "219.063",
    height: "161.415",
    style: {"stroke":"rgb(0, 0, 0)","fill":"rgba(216, 216, 216, 0)"}
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "134.512",
    y: "263.901",
    width: "97.361",
    height: "303.614",
    style: {"stroke":"rgb(0, 0, 0)","fill":"rgba(216, 216, 216, 0)"}
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "252.372",
    y: "265.822",
    width: "97.361",
    height: "303.614",
    style: {"stroke":"rgb(0, 0, 0)","fill":"rgba(216, 216, 216, 0)"}
  })
], -1))


    
export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingDoorSvg',
  props: {
        message: { type: String, required: false, default: 'Loading...' }
    },
  setup(__props) {

const props = __props

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.message), 1),
    _hoisted_3
  ]))
}
}

})